import { getGroupAuthType } from "@/utils/authToken";
import { httpCalendar2 } from "@/api/calendar";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const scheduleRequests = {
  delete_schedule: function ({ context, data, headers, searchParams } = {}) {
    const filteredParams = searchParams
      ? Object.fromEntries(Object.entries(searchParams).filter(([, v]) => Boolean(v)))
      : undefined;

    return httpCalendar2
      .delete("/v1/calendar/schedule", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType(), ...headers },
        json: data,
        searchParams: filteredParams,
      })
      .json();
  },

  get_schedule: function ({ context, searchParams } = {}) {
    const filteredParams = searchParams
      ? Object.fromEntries(Object.entries(searchParams).filter(([, v]) => Boolean(v)))
      : undefined;

    return httpCalendar2
      .get("/v1/calendar/schedule", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        searchParams: filteredParams,
      })
      .json();
  },

  // GROUP_AUTH_HEADER_NAME is injected here — callers must not re-add it
  post_schedule: function ({ context, data, headers } = {}) {
    return httpCalendar2
      .post("/v1/calendar/schedule", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType(), ...headers },
        json: data,
      })
      .json();
  },

  // GROUP_AUTH_HEADER_NAME is injected here — callers must not re-add it
  put_schedule: function ({ context, data, headers } = {}) {
    return httpCalendar2
      .put("/v1/calendar/schedule", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType(), ...headers },
        json: data,
      })
      .json();
  },
};
